module.exports = __webpack_public_path__ + "media/images/top-bg-ac539fbaeffc5139311b73ead3296331.jpg";